// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const weedle: PokeData = {
  "id": 13,
  "name": "weedle",
  "height": 3,
  "weight": 32,
  "base_experience": 39,
  "types": [
    PokeType.BUG,
    PokeType.POISON
  ],
  "api_moves": [
    "poison-sting",
    "string-shot",
    "bug-bite"
  ],
  "moves": [
    "string-shot",
    "bug-bite",
    "pounce",
    "sticky-web",
    "leech-steal",
    "acid",
    "poison-jab",
    "lunge",
    "mortal-gas",
    "purify",
    "infest",
    "poison-fang",
    "pin-rush"
  ],
  "evolution_chain": {
    "id": 5,
    "item": null,
    "species": [
      {
        "name": "weedle",
        "order": 13,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kakuna",
        "order": 14,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 13,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 7,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "beedrill",
        "order": 15,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 14,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 32.5,
    "speed": 50,
    "ability_power": 35
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
